module.exports = __webpack_public_path__ + "img/arrow-up-to-dotted-line.b31b1ca9.svg";